import { Alerts } from "../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../contexts/RPCContext.js";
import { FormikTextarea } from "../../../../components/FormikFields/FormikTextarea.js";
import { FormikFilesPicker } from "../../../Files/shared/FormikFilesPicker.js";
import { FormikDateTimePicker } from "../../../../components/FormikFields/FormikDateTimePicker.js";
import { FormikText } from "../../../../components/FormikFields/FormikText.js";
import { RefsByTypeForm } from "../../../shared/RefsByTypeForm/index.js";
import { SelectLocationAndGroup } from "../SelectLocationAndGroup.js";
import { usePassDown } from "../../../PassDowns/hooks/usePassDown.js";
import dayjs from "dayjs";
import { useCallback, useEffect, useState } from "react";
import { FormLayout, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { RPCs } from "@therms/rpc-gateway";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Locations/shared/PassDown/LocationPassDownForm.tsx
var ValidationSchema = Yup.object().shape({
	activeDate: Yup.string().nullable(),
	body: Yup.string().required(),
	expireDate: Yup.string().required(),
	fileUrls: Yup.array(Yup.string()).nullable(),
	primaryImageUrl: Yup.string().nullable(),
	regionIds: Yup.array(Yup.string()).nullable(),
	title: Yup.string().required()
});
var initialState = {
	activeDate: (/* @__PURE__ */ new Date()).toISOString(),
	body: "",
	expireDate: void 0,
	fileUrls: [],
	organizationId: void 0,
	primaryImageUrl: void 0,
	regionIds: [],
	title: ""
};
var expireDate = dayjs().add(2, "weeks").toISOString();
function LocationPassDownForm({ isPortal, locationId, locationIdFilter, onCancel, onComplete, passDownId }) {
	const { rpcClient } = useRPCContext();
	const [tab, setTab] = useState("details");
	const [locationAndGroupIds, setLocationAndGroupIds] = useState([locationId]);
	const { data, loading } = usePassDown(passDownId ? { passDownId } : void 0);
	useEffect(() => {
		if (data?.passDown?.locationGroupIds?.length && data?.passDown?.locationIds?.length) return setLocationAndGroupIds([...data.passDown.locationIds, ...data.passDown.locationGroupIds]);
		if (data?.passDown?.locationIds?.length) return setLocationAndGroupIds(data.passDown.locationIds);
		if (data?.passDown?.locationGroupIds?.length) return setLocationAndGroupIds(data.passDown.locationGroupIds);
	}, [data]);
	const save = useCallback(async (values) => {
		try {
			if ("id" in values) await rpcClient.call(RPCs.Locations.UpdateLocationPassDown.v1, {
				locationAndGroupIds,
				passDown: values
			});
			else await rpcClient.call(RPCs.Locations.CreateLocationPassDown.v1, {
				isPortalPassDown: isPortal,
				locationAndGroupIds,
				passDown: values
			});
			onComplete();
			Alerts.success(`PassDown saved`);
		} catch (err) {
			Alerts.error("There was a problem saving the Pass Down", err.message);
			console.log("save() err", err);
		}
	}, [
		isPortal,
		locationAndGroupIds,
		onComplete
	]);
	const handleDelete = useCallback(async () => {
		try {
			await rpcClient.call(RPCs.PassDowns.DeletePassDown.v1, { passDownId });
			onComplete();
		} catch (err) {
			console.log("handleDelete() err", err);
		}
	}, [passDownId, onComplete]);
	return /* @__PURE__ */ jsx(Formik, {
		initialValues: {
			...initialState,
			expireDate,
			...data?.passDown
		},
		onSubmit: save,
		enableReinitialize: true,
		validationSchema: ValidationSchema,
		children: ({ isSubmitting, submitForm }) => /* @__PURE__ */ jsxs(FormLayout, {
			space: "lg",
			loading: isSubmitting || loading,
			loadingMessage: loading ? "Loading Pass Down" : "Saving Pass Down",
			relative: false,
			children: [/* @__PURE__ */ jsxs(Tabs, {
				currentKey: tab,
				onTabClick: setTab,
				children: [/* @__PURE__ */ jsxs(Tabs.Tab, {
					tabKey: "details",
					title: "Details",
					children: [
						/* @__PURE__ */ jsx(FormikText, {
							hint: "required",
							label: "Title",
							name: "title",
							placeholder: "Dangerous Individual",
							required: true
						}),
						/* @__PURE__ */ jsx(FormikTextarea, {
							hint: "required",
							label: "Description",
							name: "body",
							placeholder: "Pass Down details...",
							required: true
						}),
						/* @__PURE__ */ jsx(SelectLocationAndGroup, {
							combineSelected: true,
							hideSelectedOptions: false,
							idFilter: locationIdFilter,
							isClearable: true,
							label: "Location and Group",
							multi: true,
							name: "locationAndGroupIds",
							onChangeValue: setLocationAndGroupIds,
							placeholder: "Select Location and Group",
							value: locationAndGroupIds
						}),
						/* @__PURE__ */ jsxs(FormLayout.Section, {
							dividers: "space",
							space: "sm",
							subTitle: "A Pass down will only be active between these dates. You can set the From date to some time in the future to keep it inactive until then.",
							children: [/* @__PURE__ */ jsx(FormikDateTimePicker, {
								label: "From",
								mode: "date",
								name: "activeDate"
							}), /* @__PURE__ */ jsx(FormikDateTimePicker, {
								hint: "required",
								label: "Until",
								mode: "date",
								name: "expireDate",
								required: true
							})]
						}),
						/* @__PURE__ */ jsx(FormikFilesPicker, { name: "fileUrls" })
					]
				}), /* @__PURE__ */ jsx(Tabs.Tab, {
					tabKey: "refs",
					title: "Refs",
					children: /* @__PURE__ */ jsx(RefsByTypeForm, {
						controller: "Pass Down",
						data: data?.passDown?.refsByType
					})
				})]
			}), /* @__PURE__ */ jsx(FormLayout.Controls, {
				onCancel,
				onDelete: passDownId ? handleDelete : void 0,
				onSubmit: submitForm,
				submitting: isSubmitting && "Saving Pass Down"
			})]
		})
	});
}
//#endregion
export { LocationPassDownForm };

//# sourceMappingURL=LocationPassDownForm.js.map